import '#/PublicPath';

import { App } from './app';
import { renderSsrClient } from './rendering/client/renderSsrClient';
import { getRouteObjects } from './routing/route-objects';

renderSsrClient({
  Component: App,
  routeObjects: getRouteObjects(),
});
